import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { GLOBAL_VIEW } from "@/lib/map";

// Flies the map to a focus target: {lat, lon} (point), {bounds} (region) or {global: true}.
export const MapFocus = ({ focus }) => {
  const map = useMap();
  useEffect(() => {
    if (!focus) return;
    if (focus.global) map.flyTo(GLOBAL_VIEW.center, GLOBAL_VIEW.zoom, { duration: 1.1 });
    else if (focus.bounds) map.flyToBounds(focus.bounds, { duration: 1.2, padding: [20, 20] });
    else map.flyTo([focus.lat, focus.lon], Math.max(map.getZoom(), focus.zoom || 6), { duration: 1.1 });
  }, [focus, map]);
  return null;
};
